export class PageRedirect {
  constructor(public url: string,
              public displayName: string,
              public queryParams: Record<string, string> = {}) {
  }
}
